class InstallSelector extends HTMLElement {
  constructor() {
    super();

    // Elements
    this.addInstallSelect = this.querySelector('.install-selector__add-install');
    this.locationSearch = this.querySelector('.install-selector__location-search');
    this.locationOptionsWrapper = this.querySelector('.install-selector__location-options');
    this.locationOptions = this.querySelectorAll('.install-selector__location-option');
    this.locationNoResults = this.querySelector('.install-selector__location-no-results');
    this.locationSelected = this.querySelector('.install-selector__location-selected');
    this.locationSelectedValue = this.locationSelected?.querySelector('.install-selector__location-selected-value');
    this.locationRemove = this.querySelector('.install-selector__location-selected-remove');
    this.addInstallWrapper = this.closest('.js-product');
    this.productForm = this.addInstallWrapper.querySelector('product-form');
    this.installationProductVariantsEl = this.addInstallWrapper.querySelector('#installation-product-variants');
    this.installationProductVariants = [];

    if(this.installationProductVariantsEl){
      try {
        this.installationProductVariants = JSON.parse(this.installationProductVariantsEl.textContent)
      } catch (error){
        console.error('Error parsing installation product variants: ', error);
      }
    }

    if(this.installationProductVariants.length == 0){
      console.error('Install Selector(Install Product Metafield): No installation product variants found');
      this.classList.add('hidden');
      return;
    }

    this.addInstallSelect.addEventListener('change', this.handleAddInstallChange.bind(this));

    this.locationSearch.addEventListener('keyup', this.handleLocationSearchKeyup.bind(this));
    this.locationSearch.addEventListener('focus', this.showLocationOptions.bind(this));
    this.locationSearch.addEventListener('focusout', () => {
      setTimeout(() => {
        this.hideLocationOptions();
      }, 100);
    });

    this.locationRemove.addEventListener('click', e => this.resetSelector(false));

    this.locationOptions.forEach(option => {
      option.addEventListener('click', e => this.handleLocationOptionClick(e.target));
    });
  }

  handleAddInstallChange() {
    if (this.addInstallSelect.value == 'yes') {
      this.locationSearch.classList.add('show');
    } else {
      this.resetSelector();
    }

  }

  showLocationOptions() {
    this.locationOptionsWrapper.style.display = 'flex';
  }

  hideLocationOptions() {
    setTimeout(() => {
      this.locationOptionsWrapper.style.display = 'none';
    }, 100);
  }

  resetSelector(hideSearch = true) {
    hideSearch && this.locationSearch.classList.remove('show');
    this.locationSearch.value = '';
    this.locationSearch.dispatchEvent(new Event('keyup'));
    this.locationSelected.style.display = 'none';
    this.locationSelectedValue.textContent = '';
    this.dataset.activeLocation = '';
    this.activeLocation = '';
    this.handleOptionSelect();
  }

  handleLocationSearchKeyup() {
    let hasResults = false;
    [...this.locationOptions].forEach(option => {
        if (option.dataset.value.includes(this.locationSearch.value.toUpperCase()) || this.locationSearch.value.length == 0) {
            option.style.display = 'block';
            hasResults = true;
        } else {
            option.style.display = 'none';
        }
    });

    this.locationNoResults.style.display = hasResults ? 'none' : 'block';
  }

  handleLocationOptionClick(option) {
    this.activeLocation = option.dataset.value;
    this.dataset.activeLocation = this.activeLocation;
    this.handleOptionSelect();
    this.locationSelectedValue.textContent = option.textContent;
    this.locationSelected.style.display = 'block';
    this.locationSearch.value = '';
    this.hideLocationOptions();
  }

  handleOptionSelect() {
    let lowerCaseActiveLocation = this.activeLocation.toLowerCase();
    if(lowerCaseActiveLocation == ''){
      this.removeInstall();
    } else {
      for (let i = 0; i < this.installationProductVariants.length; i++) {
        let variant = this.installationProductVariants[i],
        variantLocations = variant.locations.map(location => location.toLowerCase().trim());
  
        if(variantLocations.includes(lowerCaseActiveLocation)) {
          this.addInstall(variant);
          break;
        }
      }
    }
  }

  addInstall(variant) {
    this.productForm.dataset.installProduct = JSON.stringify({ id: variant.id, quantity: 1, isFree: variant.price == 0 ? true : false , properties: { productTitle: this.dataset.title, installTitle: variant.title } });
    this.locationSelected.dataset.price = `+ £${variant.price / 100}`
  }

  removeInstall(){
    this.productForm.removeAttribute('data-install-product');
    this.locationSelected.removeAttribute('data-price');
  }
}

customElements.define('install-selector', InstallSelector);